import React from 'react';
import { getLocale } from 'umi';

import GameList from './GameList';
import ComponentProxy from './ComponentProxy';
import { NewGameProps } from '../types';

function NewGame(props: NewGameProps) {
  const {
    newGame,
    setActiveId,
    setGameModalVisible,
    menuWidth
  } = props;
  const noDataText = (() => {
    const isEN = getLocale() === 'en-US';
    const switchAll = () => setActiveId('all');

    if (isEN) {
      return (
        <span>
          There are no recent viewed games, please go to
          <span className='nodata-link-text' onClick={switchAll}>&nbsp;ALL Games&nbsp;</span>
          to find games.
        </span>
      );
    }
    return (
      <span>
          暂无新上线游戏，请到
        <span className='nodata-link-text' onClick={switchAll}>&nbsp;所有游戏&nbsp;</span>
          查找游戏。
      </span>
    );
    
  })();

  return (
    <ComponentProxy
      loading={false}
      noData={newGame?.length === 0}
      height='40vh'
      noDataText={noDataText}
      componentRender={() => (
        <div className="drawer-all">
          <GameList
            list={newGame}
            setGameModalVisible={setGameModalVisible}
            menuWidth={menuWidth}
          />
        </div>
      )}
    />
    
  );
};

export default NewGame;